var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-528.162923,-357.195233)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.674537,0,0,0.707892,187.43402,113.629878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.706,412.433L607.131,412.433L608.083,412.525L608.978,412.79L610.482,413.756L611.496,415.189L611.774,416.041L611.87,416.948L611.87,426.905L611.774,427.812L611.496,428.665L610.482,430.098L608.978,431.064L608.083,431.329L607.131,431.421L509.869,431.421L508.917,431.329L508.022,431.064L506.518,430.098L505.504,428.665L505.226,427.812L505.13,426.905L505.13,416.948L505.226,416.041L505.504,415.189L506.518,413.756L508.022,412.79L508.917,412.525L509.869,412.433L516.294,412.433C516.269,412.185 516.257,411.934 516.257,411.68L516.257,366.32C516.257,361.967 519.965,358.433 524.534,358.433L592.466,358.433C597.035,358.433 600.743,361.967 600.743,366.32L600.743,411.68C600.743,411.934 600.731,412.185 600.706,412.433ZM604.383,419.567L512.617,419.567L512.617,424.287L604.383,424.287L604.383,419.567ZM592.466,412.433C592.902,412.433 593.257,412.096 593.257,411.68L593.257,366.32C593.257,365.904 592.902,365.567 592.466,365.567L524.534,365.567C524.098,365.567 523.743,365.904 523.743,366.32L523.743,411.68C523.743,412.096 524.098,412.433 524.534,412.433L592.466,412.433ZM587.18,374.867L587.18,403.133L587.077,404.097L586.782,405.002L585.705,406.525L584.107,407.551L583.157,407.832L582.146,407.93L534.854,407.93L533.843,407.832L532.893,407.551L531.295,406.525L530.218,405.002L529.923,404.097L529.82,403.133L529.82,374.867L529.923,373.903L530.218,372.998L531.295,371.475L532.893,370.449L533.843,370.168L534.854,370.07L582.146,370.07L583.157,370.168L584.107,370.449L585.705,371.475L586.782,372.998L587.077,373.903L587.18,374.867ZM537.307,377.205L537.307,400.795L579.693,400.795L579.693,377.205L537.307,377.205Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765957,0,0,0.782609,201.099093,81.716972)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427,
    y: 352,
    width: 94,
    height: 92,
    style: {
      fill: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/ICON2.ea3c1320e4a6affeefc6c3d2ca28d369.svg";
export { ForwardRef as ReactComponent };